/* ============================================================
   PREMIUM WISHLIST PAGE
   Renders saved rows with quantity + add to bag, select-all,
   an "add selected" total, and a comparison table populated
   from the first two saved items.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }
  function priceToNumber(str) {
    var n = String(str || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var f = parseFloat(n);
    return isNaN(f) ? 0 : f;
  }
  function formatMoney(amount, sample) {
    var symbol = String(sample || '').replace(/[0-9.,\s]/g, '') || '';
    return symbol + amount.toFixed(2);
  }

  var ICONS = {
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
  };

  function boot() {
    var root = $('[data-pm-wishlist-root]');
    var grid = $('[data-pm-wishlist-grid]');
    if (!root || !grid) return;

    var WL = window.PremiumTheme && window.PremiumTheme.Wishlist;
    if (!WL) return;

    var bar = $('[data-pm-wishlist-bar]', root);
    var empty = $('[data-pm-wishlist-empty]', root);
    var totalEl = $('[data-pm-wishlist-total]', root);
    var addSelected = $('[data-pm-wishlist-addselected]', root);
    var addSelectedLabel = $('[data-pm-wishlist-addselected-label]', root);
    var selectAll = $('[data-pm-wishlist-selectall]', root);
    var compare = $('[data-pm-wishlist-compare]', root);

    var L = {
      add: root.dataset.labelAdd || 'Add to bag',
      remove: root.dataset.labelRemove || 'Remove',
      qty: root.dataset.labelQty || 'Quantity'
    };

    function render() {
      var items = WL.all();

      if (!items.length) {
        grid.innerHTML = '';
        if (bar) bar.hidden = true;
        if (addSelected) addSelected.hidden = true;
        if (compare) compare.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }

      if (bar) bar.hidden = false;
      if (empty) empty.hidden = true;
      if (addSelected) addSelected.hidden = false;

      if (totalEl) {
        var tpl = totalEl.dataset.template || '{n} saved notebooks';
        totalEl.textContent = tpl.replace('{n}', items.length);
      }

      grid.innerHTML = items.map(function (p, i) {
        return '<article class="pm-wlrow" data-pm-wl-row="' + esc(p.id) + '">' +
          '<label class="pm-check" style="margin:0">' +
            '<input type="checkbox" data-pm-wl-select="' + esc(p.id) + '" checked>' +
            '<span class="pm-check__box">' + ICONS.check + '</span>' +
          '</label>' +

          '<a class="pm-wlrow__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="" width="200" height="250" loading="lazy" decoding="async">' : '') +
          '</a>' +

          '<div>' +
            (p.tag ? '<span class="pm-ccard__tag" style="position:static;display:inline-block">' + esc(p.tag) + '</span>' : '') +
            '<h3 class="pm-wlrow__t"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
            (p.meta ? '<p class="pm-dcard__meta">' + esc(p.meta) + '</p>' : '') +
            '<p class="pm-fieldlabel" style="margin:1.4rem 0 .7rem">' + esc(L.qty) + '</p>' +
            '<div class="pm-miniqty">' +
              '<button type="button" data-pm-qty="down" aria-label="Decrease">' + ICONS.minus + '</button>' +
              '<input type="number" value="1" min="1" inputmode="numeric" data-pm-wl-qty aria-label="' + esc(L.qty) + '">' +
              '<button type="button" data-pm-qty="up" aria-label="Increase">' + ICONS.plus + '</button>' +
            '</div>' +
          '</div>' +

          '<div class="pm-wlrow__buy">' +
            '<p class="pm-wlrow__price" data-price="' + esc(p.price) + '">' + esc(p.price || '') + '</p>' +
            (p.variantId
              ? '<button type="button" class="pm-btn pm-btn--green pm-btn--square pm-btn--block" data-pm-wl-add="' + esc(p.variantId) + '">' + esc(L.add) + '</button>'
              : '<a class="pm-btn pm-btn--green pm-btn--square pm-btn--block" href="' + esc(p.url) + '">' + esc(L.add) + '</a>') +
            '<button type="button" class="pm-wlrow__remove" data-pm-wl-remove="' + esc(p.id) + '">' +
              ICONS.trash + esc(L.remove) +
            '</button>' +
          '</div>' +
        '</article>';
      }).join('');

      renderCompare(items);
      updateSelected();
      document.dispatchEvent(new CustomEvent('pm:rendered', { detail: { root: grid } }));
    }

    function renderCompare(items) {
      if (!compare) return;
      if (items.length < 2) { compare.hidden = true; return; }
      compare.hidden = false;
      [0, 1].forEach(function (i) {
        var head = $('[data-pm-cmp-head="' + i + '"]', compare);
        if (!head) return;
        var p = items[i];
        head.innerHTML = '<span class="pm-cmp__head">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" width="40" height="50" loading="lazy" decoding="async">' : '') +
          '<span>' + esc(p.title) + '</span></span>';
      });
    }

    function selectedRows() {
      return $$('[data-pm-wl-select]', grid).filter(function (cb) { return cb.checked; });
    }

    function updateSelected() {
      if (!addSelected) return;
      var chosen = selectedRows();
      var total = 0;
      var sample = '';
      chosen.forEach(function (cb) {
        var row = cb.closest('.pm-wlrow');
        if (!row) return;
        var priceEl = $('.pm-wlrow__price', row);
        var qtyEl = $('[data-pm-wl-qty]', row);
        var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
        var raw = priceEl ? priceEl.dataset.price : '';
        if (!sample) sample = raw;
        total += priceToNumber(raw) * qty;
      });

      addSelected.disabled = chosen.length === 0;
      if (addSelectedLabel) {
        var tpl = addSelected.dataset.template || 'Add selected to bag';
        addSelectedLabel.textContent = chosen.length
          ? tpl + '  —  ' + formatMoney(total, sample)
          : tpl;
      }
      if (selectAll) {
        var all = $$('[data-pm-wl-select]', grid);
        selectAll.checked = all.length > 0 && chosen.length === all.length;
      }
    }

    /* ---------- events ---------- */
    grid.addEventListener('change', function (e) {
      if (e.target.matches('[data-pm-wl-select], [data-pm-wl-qty]')) updateSelected();
    });
    grid.addEventListener('input', function (e) {
      if (e.target.matches('[data-pm-wl-qty]')) updateSelected();
    });

    grid.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-pm-wl-remove]');
      if (rm) { WL.remove(rm.dataset.pmWlRemove); return; }

      var add = e.target.closest('[data-pm-wl-add]');
      if (add) {
        var row = add.closest('.pm-wlrow');
        var qtyEl = row && $('[data-pm-wl-qty]', row);
        window.PremiumTheme.addToCart(add.dataset.pmWlAdd, qtyEl ? qtyEl.value : 1, add);
        return;
      }

      var step = e.target.closest('.pm-miniqty [data-pm-qty]');
      if (step) setTimeout(updateSelected, 0);
    });

    if (selectAll) {
      selectAll.addEventListener('change', function () {
        $$('[data-pm-wl-select]', grid).forEach(function (cb) { cb.checked = selectAll.checked; });
        updateSelected();
      });
    }

    if (addSelected) {
      addSelected.addEventListener('click', function () {
        var items = [];
        selectedRows().forEach(function (cb) {
          var row = cb.closest('.pm-wlrow');
          var add = row && $('[data-pm-wl-add]', row);
          var qtyEl = row && $('[data-pm-wl-qty]', row);
          if (add) items.push({ id: parseInt(add.dataset.pmWlAdd, 10), quantity: parseInt(qtyEl && qtyEl.value, 10) || 1 });
        });
        if (!items.length) return;

        addSelected.disabled = true;
        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || 'Cart error');
            if (window.PremiumTheme.toast) window.PremiumTheme.toast('Added to your bag');
            document.dispatchEvent(new CustomEvent('pm:cart:updated'));
          })
          .catch(function (err) {
            if (window.PremiumTheme.toast) window.PremiumTheme.toast(err.message || 'Something went wrong');
          })
          .finally(function () { addSelected.disabled = false; updateSelected(); });
      });
    }

    var clearBtn = $('[data-pm-wishlist-clear]', root);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        WL.all().forEach(function (i) { WL.remove(i.id); });
        if (window.PremiumTheme.toast) window.PremiumTheme.toast(clearBtn.dataset.msg || 'Wishlist cleared');
      });
    }

    var shareBtn = $('[data-pm-wishlist-share]', root);
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var items = WL.all();
        if (!items.length) return;
        var url = window.location.origin + window.location.pathname + '?items=' +
          encodeURIComponent(items.map(function (i) { return i.handle || i.id; }).join(','));
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (window.PremiumTheme.toast) window.PremiumTheme.toast(shareBtn.dataset.msg || 'Wishlist link copied');
          }).catch(function () {});
        }
      });
    }

    document.addEventListener('pm:wishlist:change', render);
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
